import { render, staticRenderFns } from "./AchiPre.vue?vue&type=template&id=230d2cdc&scoped=true&"
import script from "./AchiPre.vue?vue&type=script&lang=js&"
export * from "./AchiPre.vue?vue&type=script&lang=js&"
import style0 from "./AchiPre.vue?vue&type=style&index=0&id=230d2cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d2cdc",
  null
  
)

export default component.exports